import React, { Component } from 'react';
import { TextOnly } from '../../templates';
import { withLanguageContext } from '../../../utils/LanguageContext';

import './styles.css';

/**
 * Description
 *
 * @typedef {Object} Props
 * @prop {Object} [content]
 *
 * @augments {Component<Props>}
 */
class WhoWeAreView extends Component {

	render () {

		const {
			content,
			heading,
			subheading,
		} = this.props.content.landingPage.whoWeAre;

		return (
			<TextOnly
				{...{
					content,
					heading,
					subheading,
				}}
				className='WhoWeAreView'
			/>
		);
	}
}

export default withLanguageContext(WhoWeAreView);



// WEBPACK FOOTER //
// ./src/components/views/WhoWeAreView/WhoWeAreView.js